import React, { useEffect, useState, useContext } from 'react';
import '../styles/nav.css';
import { UserContext } from '../contexts/UserContext';
import { getLocalPart } from '../utils/email';
import {Link, useNavigate } from 'react-router-dom';
import LogoutButton from './LogoutButton';

const NavBar = () => {
  const { currentUser } = useContext(UserContext);
  const [hora, setHora] = useState('');
  const [fecha, setFecha] = useState('');

  useEffect(() => {
    const actualizarReloj = () => {
      const ahora = new Date();
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
      const segundos = String(ahora.getSeconds()).padStart(2, '0');
      setHora(`${horas}:${minutos}:${segundos}`);
    };

    const mostrarFecha = () => {
      const hoy = new Date();
      const dia = String(hoy.getDate()).padStart(2, '0');
      const mes = String(hoy.getMonth() + 1).padStart(2, '0');
      const año = hoy.getFullYear();
      setFecha(`${dia} / ${mes} / ${año}`);
    };

    mostrarFecha();
    actualizarReloj();
    const intervalo = setInterval(actualizarReloj, 1000);
    return () => clearInterval(intervalo);
  }, []);

  const isEmpresa = currentUser?.tipo === 'empresa';
  const isPaciente = currentUser?.tipo === 'paciente';
  const isTipoUsuario = currentUser?.tipo === 'usuario';
  const isAdmin = isTipoUsuario && currentUser?.permiso === 'admin';
  const displayName = getLocalPart(currentUser?.email) ?? 'Invitado';
  // const displayTipo = currentUser?.permiso ?? '';

  return (
    <header className="navbar">
      <div className="navbar-logo">
        <img src="/static/logo.png" alt="XIOS Logo" />
      </div>
      <nav className="navbar-links">
        {/* Vista reducida para Tipo Empresa */}
        {isEmpresa && (
          <Link to="/perfil">Dashboard</Link>
        )}

        {/* Vista reducida para Tipo Paciente */}
        {isPaciente && (
          <Link to="/perfil">Dashboard</Link>
        )}

        {/* Vista extendida para Tipo Usuario (Admin o Staff) */}
        {isTipoUsuario && (
          <>
            {isAdmin && <Link to="/admin">Admin</Link>}
            <Link to="/perfil">Perfil</Link>
            <Link to="/empresas">Empresas</Link>
            <Link to="/baterias">Baterías</Link>
            <Link to="/pacientes">Pacientes</Link>
            <Link to="/evaluaciones">Evaluaciones</Link>
          </>
        )}
      </nav>

      <div className="navbar-info">
        <div className="navbar-date">Fecha: <span>{fecha}</span></div>
        <div className="navbar-time">Hora: <span>{hora}</span></div>
        <div className="navbar-user">
          <span className="user-name">{displayName}</span>
          {currentUser?.permiso && <span className="user-type">{currentUser.permiso}</span>}
          <LogoutButton />
        </div>
      </div>
    </header>
  );
};

export default NavBar;
